module.exports = __webpack_public_path__ + "static/img/077_TO8_1713.7c02a9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/077_TO8_1713.jpg
// module id = BqHX
// module chunks = 0